export const gitCommit = '81f2545a'
